import React from 'react'
function PaymentButton() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_support">
               <h1>Payment Button</h1>
               <hr/>
               <p>
                  Payment button is another important feature of the Safexpay payment gateway system that allows merchants to add a simple, customizable button to their website or app to accept payments from customers. 
               </p>
               <h5>Key Features:</h5>
               <ul>
                  <li>
                     <b>Easy to integrate: </b> Payment button is easy to integrate with a website or app using simple copy-paste code snippets or APIs, without requiring any technical expertise.
                  </li>
                  <li>
                     <b>Customizable:</b> Payment button can be customized with the merchant's branding, including the logo, colour scheme, and other design elements, to provide a seamless and professional payment experience for customers.
                  </li>
                  <li>
                     <b>Secure:</b> Payment button uses industry-standard encryption to protect customer data and prevent fraud, ensuring a secure payment experience for customers.
                  </li>
                  <li>
                     <b>Multiple payment options:</b> Payment button supports multiple payment options, including credit cards, debit cards, net banking, and UPI, providing flexibility and convenience for customers.
                  </li>
                  <li>
                     <b>Mobile-friendly:</b> Payment button is mobile-friendly, meaning that customers can easily complete payments using their smartphones, making the payment process more accessible and convenient.
                  </li>
               </ul>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default PaymentButton